import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__table-from-json';
const FORM_SELECTOR = '.js__table-form';
const TABLE_INPUT_SELECTOR = '.js__table-input';
const SUCCESS_MESSAGE_SELECTOR = '.positive.sylius-flash-message';
const ERROR_MESSAGE_SELECTOR = '.js__error-message';
const TABLE_ACTION_BUTTONS_SELECTOR = '.js__table-action-buttons';
const INPUT_ERROR_MESSAGE_SELECTOR = '.js__input-error-message';
const REMOVE_COLUMN_BUTTON_SELECTOR = '.js__remove-column';
const REMOVE_ROW_BUTTON_SELECTOR = '.js__remove-row';
const ADD_COLUMN_BUTTON_SELECTOR = '.js__table-add-row';
const ADD_ROW_BUTTON_SELECTOR = '.js__table-add-column';
const ROW_INPUT_SELECTOR = '.js__row-input';
const COLUMN_INPUT_SELECTOR = '.js__column-input';
const RELOAD_TABLE_BUTTON_SELECTOR = '.js__reload-table-btn';
const SUBMIT_TABLE_BUTTON_SELECTOR = '.js__submit-btn';
const ROW_DROPDOWN_SELECTOR = '.js__row-dropdown';
const COLUMN_DROPDOWN_SELECTOR = '.js__column-dropdown';
export class TableFormJson {
    static $table;
    static $form;
    static fetchedTableData;
    static tableData;
    static init() {
        this.$table = $(ELEMENT_SELECTOR);
        this.$form = $(FORM_SELECTOR);
        if (!this.$table.length) {
            return;
        }
        this.initDataLoading();
        this.initTableInputsChangeHandler();
        this.initFormSubmitHandler();
        this.initReloadTableHandler();
        this.initRowAndColumRemoveHandler();
        this.initRowAndColumAddHandler();
        this.initRowAndColumChangeHandler();
    }
    static initRowAndColumRemoveHandler() {
        const $body = $('body');
        $body.on('click', REMOVE_COLUMN_BUTTON_SELECTOR, e => {
            const $button = $(e.currentTarget);
            const { productId } = $button.data();
            const columnIndex = $button.parent().index();
            const mapIndexToRemove = [];
            this.tableData.mapping.forEach((map, index) => {
                if (map.product === productId) {
                    mapIndexToRemove.push(index);
                }
            });
            this.tableData.mapping = this.tableData.mapping.filter((map, index) => {
                return !mapIndexToRemove.includes(index);
            });
            this.tableData.products = this.tableData.products.filter((product, index) => {
                return product.id !== productId;
            });
            $(ELEMENT_SELECTOR)
                .find(`tr th:nth-child(${columnIndex + 1}), tr td:nth-child(${columnIndex + 1})`)
                .remove();
            if ($(ELEMENT_SELECTOR).find(`thead th`).length < 2) {
                this.addColumn();
            }
            this.setHiddenColumnSelectOptions();
            this.showActionButtons();
        });
        $body.on('click', REMOVE_ROW_BUTTON_SELECTOR, e => {
            const $button = $(e.currentTarget);
            const { segmentId } = $button.data();
            const rowIndex = $button.parent().parent().index();
            const mapIndexToRemove = [];
            this.tableData.mapping.forEach((map, index) => {
                if (map.segment === segmentId) {
                    mapIndexToRemove.push(index);
                }
            });
            this.tableData.mapping = this.tableData.mapping.filter((map, index) => {
                return !mapIndexToRemove.includes(index);
            });
            this.tableData.segments = this.tableData.segments.filter((segment, index) => {
                return segment.id !== segmentId;
            });
            $(ELEMENT_SELECTOR)
                .find(`tbody tr:nth-child(${rowIndex + 1})`)
                .remove();
            if (!$(ELEMENT_SELECTOR).find(`tbody tr`).length) {
                this.addRow();
            }
            this.setHiddenRowSelectOptions();
            this.showActionButtons();
        });
    }
    static initRowAndColumAddHandler() {
        const $body = $('body');
        $body.on('click', ADD_ROW_BUTTON_SELECTOR, () => {
            this.addColumn();
        });
        $body.on('click', ADD_COLUMN_BUTTON_SELECTOR, () => {
            this.addRow();
        });
    }
    static addColumn() {
        const $dropdown = $(this.$table.data('column-input'));
        const rowsLength = this.getRowsToAddCount();
        this.$table.find('thead tr').append($dropdown);
        for (let i = 0; i < rowsLength; i++) {
            const tableRowElement = this.$table.find('tbody tr').get(i);
            const $row = $(tableRowElement);
            const segmentId = $row.find(REMOVE_ROW_BUTTON_SELECTOR).data('segment-id');
            $row.append(`<td><div class="field"><input class="js__table-input" type="number" data-segment-id="${segmentId}" value="0"></div></td>`);
        }
        this.$table.parent().animate({ scrollLeft: this.$table.width() }, 0);
        $(document).trigger('collection-form-add', [$dropdown]);
        this.setHiddenColumnSelectOptions();
    }
    static addRow() {
        const $row = $('<tr></tr>');
        const $dropdown = $(this.$table.data('row-input'));
        const columnsLength = this.getColumnsToAddCount();
        const rowsCount = this.$table.find('tr').length;
        $dropdown.css('z-index', 9999 - rowsCount);
        $row.append($dropdown);
        for (let i = 0; i < columnsLength; i++) {
            const $columnButton = this.$table.find(`thead ${REMOVE_COLUMN_BUTTON_SELECTOR}`);
            const columnButtonElement = $columnButton.get(i);
            const productId = $(columnButtonElement).data('product-id');
            $row.append(`<td><div class="field"><input class="js__table-input" type="number" data-product-id="${productId}" value="0"></div></td>`);
        }
        this.$table.find('tbody').append($row);
        this.$table.parent().animate({ scrollTop: this.$table.height() }, 0);
        $(document).trigger('collection-form-add', [$dropdown]);
        this.setHiddenRowSelectOptions();
    }
    static initRowAndColumChangeHandler() {
        const $body = $('body');
        $body.on('change', ROW_INPUT_SELECTOR, e => {
            const $select = $(e.currentTarget);
            $select.closest('td').find(REMOVE_ROW_BUTTON_SELECTOR).data('segment-id', Number($select.val()));
            const $inputs = $select.closest('tr').find(TABLE_INPUT_SELECTOR);
            $inputs.each((index, element) => {
                $(element).data('segment-id', Number($select.val()));
                const { segmentId, productId } = $(element).data();
                if (segmentId && productId) {
                    this.addFieldToMapping(segmentId, productId, Number($(element).val()));
                }
            });
            this.showActionButtons();
            this.setHiddenRowSelectOptions();
        });
        $body.on('change', COLUMN_INPUT_SELECTOR, e => {
            const $select = $(e.currentTarget);
            $select.closest('th').find(REMOVE_COLUMN_BUTTON_SELECTOR).data('product-id', Number($select.val()));
            const columnIndex = $select.closest('th').index();
            this.$table.find(`tbody tr td:nth-child(${columnIndex + 1}) ${TABLE_INPUT_SELECTOR}`).each((index, element) => {
                $(element).data('product-id', Number($select.val()));
                const { segmentId, productId } = $(element).data();
                if (Number(segmentId) && Number(productId)) {
                    this.addFieldToMapping(segmentId, productId, Number($(element).val()));
                }
            });
            this.showActionButtons();
            this.setHiddenColumnSelectOptions();
        });
    }
    static addFieldToMapping(segmentId, productId, value) {
        //@ts-ignore
        const index = this.tableData.mapping.findLastIndex((map) => {
            return map.segment === segmentId;
        });
        if (Number(segmentId) && Number(productId)) {
            if (index === -1) {
                this.tableData.mapping.push({ segment: segmentId, product: productId, points: value });
            }
            else {
                this.tableData.mapping.splice(index + 1, 0, { segment: segmentId, product: productId, points: value });
            }
        }
    }
    static initReloadTableHandler() {
        $(RELOAD_TABLE_BUTTON_SELECTOR).on('click', () => {
            $(SUCCESS_MESSAGE_SELECTOR).hide().removeClass('transition hidden');
            $(ERROR_MESSAGE_SELECTOR).hide().removeClass('transition hidden');
            this.tableData = JSON.parse(JSON.stringify(this.fetchedTableData));
            this.renderTable(this.fetchedTableData);
            this.hideActionButtons();
        });
    }
    static initDataLoading() {
        const { jsonUrl } = this.$table.data();
        $.ajax({
            type: 'GET',
            url: jsonUrl,
            beforeSend: () => {
                this.$form.addClass('loading');
            },
        })
            .done((data) => {
            this.tableDateLoadedSuccessfulHandler(data);
        })
            .always(() => {
            this.$form.removeClass('loading');
        });
    }
    static tableDateLoadedSuccessfulHandler(data) {
        this.fetchedTableData = this.sortMappingInTableData(JSON.parse(JSON.stringify(data)));
        this.tableData = this.sortMappingInTableData(JSON.parse(JSON.stringify(data)));
        this.renderTable(data);
        if (!data.mapping.length) {
            this.addRow();
            this.addColumn();
        }
        this.hideActionButtons();
    }
    static renderTable(data) {
        this.$table.html('');
        const { topHeaderTitle, leftHeaderTitle } = this.$table.data();
        const $header = $('<thead></thead>');
        const $headerRow = $('<tr></tr>');
        $headerRow.append(`<th class="min-max-width-200" style="z-index: 9999">${leftHeaderTitle} \\ ${topHeaderTitle}</th>`);
        $.each(data.products, (index, product) => {
            $headerRow.append(`<th class="min-max-width-200"><i class="close icon text-red cursor-pointer js__remove-column" data-product-id="${product.id}"></i>${product.code}<br>${product.name.replace(product.code, '')}</th>`);
        });
        $header.append($headerRow);
        const $tableBody = $('<tbody></tbody>');
        $.each(data.segments, (index, segment) => {
            const $bodyRow = $('<tr></tr>');
            $bodyRow.append(`<td><i class="close icon text-red cursor-pointer js__remove-row" data-segment-id="${segment.id}"></i>${segment.name}</td>`);
            $.each(data.products, (index, product) => {
                $.each(data.mapping, (index, map) => {
                    if (map.segment == segment.id && map.product === product.id) {
                        $bodyRow.append(`<td><div class="field"><input class="js__table-input" data-segment-id="${segment.id}" data-product-id="${product.id}" type="number" value="${map.points}"></div></td>`);
                    }
                });
            });
            $tableBody.append($bodyRow);
        });
        this.$table.append($header).append($tableBody);
    }
    static initFormSubmitHandler() {
        const url = this.$form.data('action');
        $(SUBMIT_TABLE_BUTTON_SELECTOR).on('click', e => {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url,
                data: JSON.stringify(this.tableData.mapping),
                contentType: 'application/json',
                beforeSend: () => {
                    this.$form.addClass('loading');
                    $(SUCCESS_MESSAGE_SELECTOR).hide().removeClass('transition hidden');
                    $(ERROR_MESSAGE_SELECTOR).hide().removeClass('transition hidden');
                },
            })
                .done(() => {
                window.location.reload();
            })
                .fail(data => {
                this.$form.removeClass('loading');
                $(ERROR_MESSAGE_SELECTOR).show();
                if (data.responseJSON.errors) {
                    this.printInputsErrors(data.responseJSON.errors);
                }
            });
        });
    }
    static initTableInputsChangeHandler() {
        $('body').on('change', TABLE_INPUT_SELECTOR, e => {
            const $input = $(e.currentTarget);
            const { productId, segmentId } = $input.data();
            this.removeInputErrors($input);
            const mappingIndexToUpdate = this.tableData.mapping.findIndex(item => item.product === productId && item.segment === segmentId);
            if (mappingIndexToUpdate !== -1 && Number(productId) && Number(segmentId)) {
                this.tableData.mapping[mappingIndexToUpdate].points = Number($input.val());
            }
            this.showActionButtons();
        });
    }
    static printInputsErrors(errors) {
        $(TABLE_INPUT_SELECTOR).each((index, element) => {
            const error = errors[`[${index}].points`];
            if (error) {
                const $field = $(element).closest('.field');
                $field.addClass('error');
                const $errorMessage = $field.find(INPUT_ERROR_MESSAGE_SELECTOR);
                if ($errorMessage.length) {
                    $errorMessage.text(error[0]);
                }
                else {
                    $field.append(`<div class="ui red pointing label js__input-error-message">${error[0]}</div>`);
                }
            }
        });
    }
    static sortMappingInTableData(tableData) {
        const mapping = tableData.mapping.sort((aMap, bMap) => {
            const aSegmentIndex = tableData.segments.findIndex(segment => segment.id === aMap.segment);
            const bSegmentIndex = tableData.segments.findIndex(segment => segment.id === bMap.segment);
            const aProductIndex = tableData.products.findIndex(product => product.id === aMap.product);
            const bProductIndex = tableData.products.findIndex(product => product.id === bMap.product);
            if (aSegmentIndex < bSegmentIndex) {
                return -1;
            }
            else if (aSegmentIndex > bSegmentIndex) {
                return 1;
            }
            else {
                if (aProductIndex < bProductIndex) {
                    return -1;
                }
                else if (aProductIndex > bProductIndex) {
                    return 1;
                }
                else {
                    return 0;
                }
            }
        });
        return { ...tableData, mapping };
    }
    static removeInputErrors($input) {
        const $field = $input.closest('.field');
        $field.removeClass('error');
        $field.find(INPUT_ERROR_MESSAGE_SELECTOR).remove();
    }
    static getColumnsToAddCount() {
        return this.$table.find('thead tr').first().children().length - 1;
    }
    static getRowsToAddCount() {
        return this.$table.find('tbody tr').length;
    }
    static showActionButtons() {
        $(TABLE_ACTION_BUTTONS_SELECTOR).show();
    }
    static hideActionButtons() {
        $(TABLE_ACTION_BUTTONS_SELECTOR).hide();
    }
    static setHiddenRowSelectOptions() {
        $(ROW_DROPDOWN_SELECTOR).each((index, element) => {
            $(element).data('hidden-options', this.getAllSelectedSegments());
        });
    }
    static setHiddenColumnSelectOptions() {
        $(COLUMN_DROPDOWN_SELECTOR).each((index, element) => {
            $(element).data('hidden-options', this.getAllSelectedProducts());
        });
    }
    static getAllSelectedSegments() {
        const selectedSegments = this.tableData.mapping.map(map => {
            return map.segment;
        });
        $(ROW_DROPDOWN_SELECTOR).each((index, element) => {
            const inputValue = $(element).dropdown('get value');
            if (inputValue) {
                selectedSegments.push(Number(inputValue));
            }
        });
        // @ts-ignore
        return [...new Set(selectedSegments)];
    }
    static getAllSelectedProducts() {
        const selectedProducts = this.tableData.mapping.map(map => {
            return map.product;
        });
        $(COLUMN_DROPDOWN_SELECTOR).each((index, element) => {
            const inputValue = $(element).dropdown('get value');
            if (inputValue) {
                selectedProducts.push(Number(inputValue));
            }
        });
        // @ts-ignore
        return [...new Set(selectedProducts)];
    }
}
